import type { FC, SVGAttributes } from "react";
import { Briefcase, Inbox, Megaphone, MessageSquare, Users } from "lucide-react";

export const AdminNavIconMessage: FC<SVGAttributes<SVGElement>> = (props) => (
    <MessageSquare size={32} strokeWidth={1.5} aria-hidden {...props} />
);

export const AdminNavIconUsers: FC<SVGAttributes<SVGElement>> = (props) => (
    <Users size={32} strokeWidth={1.5} aria-hidden {...props} />
);

export const AdminNavIconInbox: FC<SVGAttributes<SVGElement>> = (props) => (
    <Inbox size={32} strokeWidth={1.5} aria-hidden {...props} />
);

export const AdminNavIconMegaphone: FC<SVGAttributes<SVGElement>> = (props) => (
    <Megaphone size={32} strokeWidth={1.5} aria-hidden {...props} />
);

export const AdminNavIconBriefcase: FC<SVGAttributes<SVGElement>> = (props) => (
    <Briefcase size={32} strokeWidth={1.5} aria-hidden {...props} />
);
